/**
 * Сервис который принимает на вход массив ответов с разными вариантами точек отправления и нормализует
 */
import DG from '2gis-maps';

const getResults = payload => {
  if (!payload) {
    return null;
  }

  return payload.map(item => {
    const isError = !!item.meta?.error?.message;

    return isError ? { items: [] } : item.result;
  });
};

const getItems = payload => {
  if (!payload) {
    return null;
  }
  const items = payload.map(item => item.items);

  const flattenItems = [];

  items.forEach(item => {
    item.forEach(subItem => {
      flattenItems.push(subItem);
    });
  });

  return flattenItems;
};

const getMetroStation = payload => payload.filter(item => {
    if (item.subtype === 'metro') {
      return true;
    }

    // порочный способ определить станцию метро
    // временно закоментирую его
    // const isMetro = /метро/i.test(item.name.trim().toLowerCase());
    // if (isMetro) {
    //   return true;
    // }

    return false;
  });

const getRouteApiResponseParams = ({ metroStations, selectedMfc }) => {
  const points = [];
  metroStations.forEach(metroStation => {
    metroStation.platforms.forEach(platform => {
      const centroid = platform?.geometry?.centroid;
      const parseWkt = DG.Wkt.toLatLngs(centroid)[0];
      const { lat, lng } = parseWkt;
      const lon = lng;
      points.push({
        responseParams: {
          enable_schedule: false,
          locale: 'ru',
          source: {
            name: metroStation?.name,
            point: {
              lat,
              lon,
            },
          },
          target: {
            name: selectedMfc.name,
            point: {
              lat: selectedMfc.latitude,
              lon: selectedMfc.longitude,
            },
          },
          purpose: 'routeSearch',
          transport: [
            'pedestrian',
            'bus',
            'trolleybus',
            'tram',
            'shuttle_bus',
            'suburban_train',
            'funicular_railway',
            'river_transport',
            'cable_car',
            'light_rail',
            'premetro',
          ],
        },
        routeStartPoint: {
          className: 'routeStartPoint',
          latitude: lat,
          longitude: lon,
        },
        originalData: platform,
      });
    });
  });

  return points;
};

const getStartPoints = ({ response, selectedMfc }) => {
  const results = getResults(response);
  const items = getItems(results);
  const metroStations = getMetroStation(items);
  return getRouteApiResponseParams({ metroStations, selectedMfc });
};

export default getStartPoints;
